var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "b-col",
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-lg": "2",
                  "label-align-lg": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Y-tunnus")))
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.company.BusinessId) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-lg": "2",
                  "label-align-lg": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Puhelinnumero")))
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.company.Phone) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            !_vm.offerRequest
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-lg": "2",
                      "label-align-lg": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Yhteyshenkilön etunimi")))
                    ]),
                    _vm._v(" "),
                    _vm.contactPersons.length > 0
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.contactPersons[0].FirstName))
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-col",
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-lg": "2",
                  "label-align-lg": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Yrityksen nimi")))
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.company.CompanyName) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-lg": "2",
                  "label-align-lg": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Sähköposti")))
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.company.Email) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            !_vm.offerRequest
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-lg": "2",
                      "label-align-lg": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Yhteyshenkilön sukunimi")))
                    ]),
                    _vm._v(" "),
                    _vm.contactPersons.length > 0
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.contactPersons[0].LastName))
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.offerRequest
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-lg": "2",
                      "label-align-lg": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Yhteyshenkilön sähköpostiosoite")))
                    ]),
                    _vm._v(" "),
                    _vm.contactPersons.length > 0
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.contactPersons[0].Email))
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }